var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReleaseNotes = function SvgReleaseNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 72,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 54.5v-30h42v30c0 3.375-2.719 6-6 6H32c-3.375 0-6-2.625-6-6ZM36.5 32c-.844 0-1.5.75-1.5 1.5 0 .844.656 1.5 1.5 1.5h21c.75 0 1.5-.656 1.5-1.5 0-.75-.75-1.5-1.5-1.5h-21Zm0 9c-.844 0-1.5.75-1.5 1.5 0 .844.656 1.5 1.5 1.5h21c.75 0 1.5-.656 1.5-1.5 0-.75-.75-1.5-1.5-1.5h-21Zm0 9c-.844 0-1.5.75-1.5 1.5 0 .844.656 1.5 1.5 1.5h9c.75 0 1.5-.656 1.5-1.5 0-.75-.75-1.5-1.5-1.5h-9Z",
    fill: "url(#release-notes_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 19.5c0-3.281-2.719-6-6-6H32c-3.375 0-6 2.719-6 6v3h42v-3Z",
    fill: "#5298F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "release-notes_svg__a",
    x1: 47.001,
    y1: 74,
    x2: 47.001,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })))));
};

export default SvgReleaseNotes;